import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  clearLocalization,
  initializeNewLocalization,
} from "../../app/slices/TrainingLocalizationSlice";
import {
  TrainingType,
  createNewTraining,
} from "../../app/slices/TrainingSlice";

import { BreadcrumbItem } from "../../components/PiBreadcrumbs";
import { useCreateTraining } from "../../hooks/CreateTrainingHook";
import DashboardHeader from "../dashboard/DashboardHeader";
import "../pages/page.css";
import NewTrainingWizard from "./NewTrainingWizard";
import "./NewTrainingPage.css";

export default function NewTrainingPage() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { create360Training, create3DTraining } = useCreateTraining();
  const breadcrumbItems: BreadcrumbItem[] = [
    { name: "Play It - Creator" },
    { name: t("dashboard"), link: "/" },
    { name: t("newTraining") },
  ];

  async function onCreateNew360Project(name: string, refLanguage: string) {
    // create new training w/ api, save first version, can be changed later
    var newTrainingId = await create360Training(name, "", 1, refLanguage);

    // clear loc from previous course
    dispatch(clearLocalization());
    dispatch(initializeNewLocalization());

    dispatch(
      createNewTraining({
        trainingname: name,
        trainingDescription: "",
        trainingType: TrainingType.Training360,
      })
    );

    navigate("/trainingEditor/" + newTrainingId);
  }

  async function onCreateNew3DProject(
    name: string,
    refLanguage: string,
    environmentId: string
  ) {
    var newTrainingId = await create3DTraining(
      name,
      "",
      0,
      refLanguage,
      environmentId
    );

    dispatch(clearLocalization());
    dispatch(initializeNewLocalization());

    dispatch(
      createNewTraining({
        trainingname: name,
        trainingDescription: "",
        trainingType: TrainingType.Training3D,
      })
    );

    navigate("/trainingEditor/" + newTrainingId);
  }

  return (
    <>
      <div className="page-root" data-testid="new-training-page">
        <div className="page-header">
          <DashboardHeader compact breadcrumbs={breadcrumbItems} />
        </div>
        <div className="page-content page-content-margin">
          <div className="page-content-flex" data-testid="new-training-content">
            <NewTrainingWizard
              onCreate360={onCreateNew360Project}
              onCreate3D={onCreateNew3DProject}
              onCancel={() => navigate("/")}
            />
          </div>
        </div>
      </div>
    </>
  );
}
